import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Paper } from "@mui/material";
import axios from "axios";
import { urlConfig } from "./config";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Alert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const CampaignImageUpload = () => {
  const [bucketDropDownList, setBucketDropDownList] = useState([]);
  const [image, setImage] = useState(null);
  const [imageCount, setImageCount] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [responseConfirm, setResponseConfirm] = useState(false);
  const [getImageConfirm, setGetImageConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getImage, setGetImage] = useState([]);
  const [response, setResponse] = useState([
    {
      fileName: "",
      fileUrl:
        "",
    },
  ]);
  const [error, setError] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("Something went wrong. Kindly contact CMS team");
  const [totalPages, setTotalPages] = useState(0);
  const handleChangePage = (event,page) => {
    let endPage;
    let startPage
    endPage = page*20;
    startPage = endPage - 19;
    axios.get(`${urlConfig.cmsURL}/api/v1/files/getlistOfSpecificFolderImages?dirname=${selectedItem}&start=${startPage}&end=${endPage}`)
    .then((res)=>{
      setGetImage(res.data);
    })
  }

  const handleChange = (event) => {
    setLoading(true)
    setSelectedItem(event.target.value)
    axios.get(`${urlConfig.cmsURL}/api/v1/files/getlistOfSpecificFolder?dirname=${event.target.value}`)
    .then((res=>{
      setImageCount(res.data.Image_count)
      setTotalPages(Math.ceil(res.data.Image_count / 20))
      setLoading(false)
    }))
    ;

    

  };

  const handleGetImages = (e) => {
    e.preventDefault();
    axios.get(`${urlConfig.cmsURL}/api/v1/files/getlistOfSpecificFolderImages?dirname=${selectedItem}&start=1&end=20`)
    .then((res)=>{
      setGetImage(res.data);
      setGetImageConfirm(true)
    })
  }

  const handleImageUpload = (e) => {
    setImage(e.target.files);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    for (let i = 0; i < image.length; i++) {
      formData.append("ImageUpload", image[i]);
    }

    formData.append("CampaignList", selectedItem);
    formData.append("userEmail", userEmail);

    try {
      const response = await axios.post(
        `${urlConfig.cmsURL}/api/v1/files/uploadImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setResponse(response.data);
      setResponseConfirm(true);
    } catch (error) {
      setError(true);
      console.log(error);
    }
  };

  useEffect(() => {
    setUserEmail(sessionStorage.getItem("userEmail"));
    axios
      .get(`${urlConfig.cmsURL}/api/v1/files/getlistOfBucket`)
      .then((e) => {
        setBucketDropDownList(e.data);
      })
      .catch((e) => {
        setError(true);
        console.log(e);
      });
  }, []);

  return (
    <>
      <Paper sx={{ m: 3, p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Stack  direction="row" spacing={30}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl sx={{ ml:5, mb:5, mt:2, width: 400 }}>
              <TextField
                id="outlined-select-currency"
                select
                label="Campaign folder"
                helperText="Please select folder to view and upload image"
                required
                onChange={handleChange}
              >
                {bucketDropDownList.map((e, index) => (
                  <MenuItem key={index} value={e}>
                    {e}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Box>
          <Box>
            <Stack sx={{mt:3}}>
              <Typography>Image count</Typography>
              <Stack direction='row' spacing={3}>
            {imageCount ? <Button onClick={handleGetImages} sx={{ml:3}}>{imageCount}</Button>:<Button sx={{ml:3}}>NIL</Button>}
           {loading &&  <CircularProgress size={25}  />}
            </Stack>
            </Stack>
           
          </Box>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: 5, mb:3 }}>
            <Button variant="outlined" component="label">
              <input
                type="file"
                id="image"
                name="image"
                accept="image/*"
                onChange={handleImageUpload}
                multiple
                required
              />
            </Button>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Stack>
        </form>
        {error && <Alert severity="error">{errorMsg}</Alert>}
      </Paper>
{responseConfirm &&
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">Image Name</TableCell>
              <TableCell align="center">Image URL</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {response.map((row,index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">
                  <img
                  key={index}
                    src={row.fileUrl}
                    alt={row.fileName}
                    width="50"
                    height="60"
                  />
                </TableCell>
                <TableCell component="th" scope="row" align="center">
                  {row.fileName}
                </TableCell>
                <TableCell align="center">{row.fileUrl.replace(`${urlConfig.gCloudUrl}`,`${urlConfig.akamaiUrl}`)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
}

{getImageConfirm &&
<Paper>
 <Box>
  <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">Image URL</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
      {
        getImage.map((row,index)=>(
          <TableRow key={index}>
            <TableCell align="center">
             <img src={row.Image_url.replace(`${urlConfig.gCloudUrl}`,`${urlConfig.akamaiUrl}`)}  
             width="60" 
             height="70" />
            </TableCell>
            <TableCell align="center">
              {row.Image_url.replace(`${urlConfig.gCloudUrl}`,`${urlConfig.akamaiUrl}`)}
            </TableCell>
          </TableRow>
        ))
      }
      </TableBody>
    </Table>
  </TableContainer>
  <Stack direction='row' justifyContent="center" sx={{pt:2, pb:2}}>
  <Pagination count={totalPages} color="primary" onChange={handleChangePage} />
    </Stack>
  </Box>
</Paper>
}
    </>
  );
};

export default CampaignImageUpload;
